import { CardHookCtx, CardHooks } from "./registry";

export const relentlessEnd: CardHooks = {
  onAttackPlay: (ctx) => {
    // The engine defers the chainStreak update until AFTER on-play hooks
    // fire, so ctx.game.chainStreak is the PRIOR streak — exactly the
    // number of consecutive chain attacks played before this one.
    const bonus = ctx.game.chainStreak ?? 0;
    return {
      boostCurrentAttackPower: bonus,
      slotKeywordGrants: ["Piercing"],
      log: [`${ctx.card.name} gains +${bonus} power and Piercing.`],
    };
  },
};